import { z } from 'zod'
import { REQUIRED_FIELD_MESSAGE } from './invitation.schema'

//@ts-ignore
export const ResetPasswordSchema = z
  .object({
    password: z.string({ required_error: REQUIRED_FIELD_MESSAGE }).min(8, {
      message: 'La contraseña debe tener al menos 8 caracteres',
    }),
    passwordConfirmation: z.string({ required_error: REQUIRED_FIELD_MESSAGE }),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: 'Las contraseñas no coinciden',
    path: ['passwordConfirmation'],
  })

export interface IResetPasswordSchema
  extends z.infer<typeof ResetPasswordSchema> {}
